import { createNamespacer, createReducer } from "../utils/reducers";

const initialState = {
  isLoggedIn: false,
  user: null,
  tenantDetails: null,
  userDetails: null,
};

const namespacer = createNamespacer("SESSION");

const handlers = {
  [namespacer("SET_IS_LOGGED_IN")]: (state: any, action: any) => {
    return {
      ...state,
      isLoggedIn: action.payload.value,
      tenantDetails: action.payload.tenantDetails,
      userDetails: action.payload.userDetails,
    };
  },
};

const reducer = createReducer(initialState, handlers, ["SESSION"]);

export default reducer;
